export default {
  RobotoRegular: 'Roboto Regular',
  RobotoBold: 'Roboto Bold',
  RobotoBlack: 'Roboto Black',
};
